import { render } from "./ViewUser.vue?vue&type=template&id=4a9c1bd6&scoped=true"
import script from "./ViewUser.vue?vue&type=script&lang=js"
export * from "./ViewUser.vue?vue&type=script&lang=js"

import "./ViewUser.vue?vue&type=style&index=0&id=4a9c1bd6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a9c1bd6"]])

export default __exports__